"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _FormattedNumber = _interopRequireDefault(require("I18n/components/FormattedNumber"));

var _MerchandiseSelectors = require("../../../selectors/MerchandiseSelectors");

var UnitTypes = _interopRequireWildcard(require("pricing-pages-unified-ui/constants/UnitTypes"));

var _urls = require("pricing-pages-unified-ui/utils/urls");

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var IncludedUnitsSubtext = function IncludedUnitsSubtext(_ref) {
  var merchandiseId = _ref.merchandiseId,
      className = _ref.className,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
  var merchandiseMap = (0, _reactRedux.useSelector)(_MerchandiseSelectors.merchandiseSelector);
  var merchUnitType = (0, _reactRedux.useSelector)(function (state) {
    return (0, _MerchandiseSelectors.merchUnitTypeSelector)(state, merchandiseId);
  });
  if (!merchUnitType) return null;
  var includedUnits = merchandiseMap[merchandiseId].includedAdditionalUnits;
  var stringKey;
  var messageProps = {
    elements: {
      Number: _FormattedNumber.default
    },
    options: {
      value: includedUnits
    }
  };

  if (merchUnitType === UnitTypes.MARKETING_CONTACT) {
    stringKey = 'pricingPage.highlightedMerchCards.includes.contactsMCStartsAt_jsx';
    messageProps = {
      elements: {
        Number: _FormattedNumber.default,
        Link: _UILink.default
      },
      options: {
        value: includedUnits,
        href: _urls.MC_LANDING_PAGE_URL,
        external: true,
        onClick: function onClick() {
          return (0, _getUsageTracker.default)().track('externalLinkClick', {
            name: 'included-units-subtext'
          });
        }
      }
    };
  } else if (merchUnitType === UnitTypes.USER) {
    stringKey = 'pricingPage.highlightedMerchCards.includes.usersStartsAt_jsx';
  } else if (merchUnitType === UnitTypes.CONTACT) {
    stringKey = 'pricingPage.highlightedMerchCards.includes.contactsStartsAt_jsx';
  }

  return _react.default.createElement("div", {
    className: className,
    style: style
  }, _react.default.createElement(_Small.default, {
    use: "help",
    className: "m-right-2"
  }, _react.default.createElement(_FormattedJSXMessage.default, Object.assign({
    message: stringKey
  }, messageProps))));
};

var _default = IncludedUnitsSubtext;
exports.default = _default;
module.exports = exports.default;